module.exports = __webpack_public_path__ + "static/media/Minimize.cd6ef840.svg";